import './assets/css/tailwind.css'
import 'typeface-oswald'
import 'typeface-crushed'
import 'font-awesome/css/font-awesome.min.css'

import axios from 'axios'
import numeral from 'numeral'
import * as uiv from 'uiv'
import locale from 'uiv/src/locale/lang/pt-BR'
import { configureCompat, createApp } from 'vue'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

import App from './App.vue'
import FormularioCache from './diretivas/FormularioCache'
import { loadBootstrapLegacy } from './plugins/bootstrap-legacy'
import DialogGlobalsPlugin from './plugins/dialog-globals'
import NativeTooltipDirective from './plugins/native-tooltip-directive'
import PosthogPlugin from './posthog'
import { captureException } from './posthog'
import router from './router'
import Autenticacao from './servicos/Autenticacao'
import { pinia } from './stores'
import { iniciarVerificacaoVersao } from './utils/versao-nova'

const autenticacao = new Autenticacao()

configureCompat({
  MODE: 2,
})

numeral.register('locale', 'pt-br', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'mil',
    million: 'milhões',
    billion: 'b',
    trillion: 't',
  },
  ordinal: function () {
    return 'º'
  },
  currency: {
    symbol: 'R$',
  },
})

numeral.locale('pt-br')
autenticacao.verificaAutenticacao()

axios.interceptors.request.use((config) => {
  if (config.url.indexOf('viacep') === -1) {
    config.headers.Authorization = 'Bearer ' + autenticacao.getToken()
    config.headers.email = autenticacao.getUsuario().email
  }
  return config
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response ? error.response.status : null
    if (!status || status >= 500) {
      captureException(error, {
        source: 'axios.response',
        status_code: status,
        request_url: error && error.config ? error.config.url : null,
        method: error && error.config ? error.config.method : null,
      })
    }
    return Promise.reject(error)
  }
)

function configurarTratamentoGlobalErros(app) {
  app.config.errorHandler = (error, vm, info) => {
    captureException(error, {
      source: 'vue.errorHandler',
      component: vm && vm.$options ? vm.$options.name : null,
      info,
    })
    console.error(error)
  }

  if (
    typeof window !== 'undefined' &&
    !window.__cardeaErrorTrackingConfigured
  ) {
    window.__cardeaErrorTrackingConfigured = true

    window.addEventListener('error', (event) => {
      captureException(
        event.error || new Error(event.message || 'window.error'),
        {
          source: 'window.error',
          filename: event.filename || null,
          lineno: event.lineno || null,
          colno: event.colno || null,
        }
      )
    })

    window.addEventListener('unhandledrejection', (event) => {
      const reason =
        event.reason instanceof Error
          ? event.reason
          : new Error(String(event.reason || 'window.unhandledrejection'))

      captureException(reason, {
        source: 'window.unhandledrejection',
      })
    })
  }
}

const bootstrap = async () => {
  await loadBootstrapLegacy()

  const app = createApp(App)
  app.use(uiv, { locale })
  app.component('SyncLoader', SyncLoader)
  app.directive('tooltip', NativeTooltipDirective)
  app.directive('formulario-cache', FormularioCache)
  app.use(DialogGlobalsPlugin)
  app.use(PosthogPlugin)
  app.use(pinia)
  app.use(router)
  configurarTratamentoGlobalErros(app)

  window.vm = app.mount('#app')
  iniciarVerificacaoVersao()
}

bootstrap()
